import { gql } from 'react-apollo';

export default gql`
  mutation updateRepublicInvestorSuitability(
    $liquidityNeeds: LiquidityNeeds!
    $riskTolerance: RiskTolerance!
    $yearsOfExperience: YearsOfExperience!
    $investmentFrequency: InvestmentFrequency!
    $investmentAllocation: Float!
    $investmentDecisionConsultProfessional: Boolean
    $investmentDecisionConsultSelf: Boolean
    $investmentDecisionConsultFamilyFriends: Boolean
    $investmentSelectionsConfirmed: Boolean
    $investmentSelectionsRepublicPrecentage: Boolean
    $investmentSelectionsRelationshipConfirmed: Boolean
    $userId:ID
  ) {
    updateRepublicInvestorSuitability(
      input: {
        liquidityNeeds: $liquidityNeeds
        riskTolerance: $riskTolerance
        yearsOfExperience: $yearsOfExperience
        investmentFrequency: $investmentFrequency
        investmentAllocation: $investmentAllocation
        investmentDecisionConsultProfessional: $investmentDecisionConsultProfessional
        investmentDecisionConsultSelf: $investmentDecisionConsultSelf
        investmentDecisionConsultFamilyFriends: $investmentDecisionConsultFamilyFriends
        investmentSelectionsConfirmed: $investmentSelectionsConfirmed
        investmentSelectionsRepublicPrecentage: $investmentSelectionsRepublicPrecentage
        investmentSelectionsRelationshipConfirmed: $investmentSelectionsRelationshipConfirmed
        userId:$userId
      }
    ) {
      _id
      suitability {
        _id
        liquidityNeeds
        riskTolerance
        yearsOfExperience
        investmentFrequency
        investmentAllocation
        investmentDecisionConsultProfessional
        investmentDecisionConsultSelf
        investmentDecisionConsultFamilyFriends
        investmentSelectionsConfirmed
        investmentSelectionsRepublicPrecentage
        investmentSelectionsRelationshipConfirmed
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/updateRepublicInvestorSuitability.js